import React from 'react';
import { useSelector } from 'react-redux';
import FullWidthContainer from '@starbucks-web/pattern-library/lib/components/full-width-container';

import StatusLevelBenefits from './status-level-benefits';
import RewardsSubnav from './subnav';
import './shared/styles/color-palette.css';
import { userLoyaltyLevelSelector } from 'rewards/app/state/selectors/sr6';

const SR6RewardsPage = () => {
  const userLoyaltyLevel = useSelector(userLoyaltyLevelSelector);

  return (
    <div className="bg-whiteSurfacePrimary1">
      <RewardsSubnav />
      <FullWidthContainer>
        <StatusLevelBenefits level={userLoyaltyLevel} />
      </FullWidthContainer>
    </div>
  );
};

export default SR6RewardsPage;
